<!-- Reusable Feature Row Template - Desktop -->
<ng-template #featureRowTpl let-feature let-plans="plans" let-columnClass="columnClass">
  <div 
    class="grid h-16 odd:bg-gray-50 even:bg-white"
    [style.grid-template-columns]="'424px repeat(' + plans.length + ', 1fr)'"
    [style.column-gap]="'0px'">
    
    <!-- Feature Name Column (424px with 24px right padding) -->
    <div class="mx-4 py-3 flex items-start gap-1" style="padding-right: 24px;">
      <div class="flex-1">
        <div class="text-sm font-semibold text-base-700">{{ feature.name }}</div>
        @if (feature.description) {
          <div class="text-xs text-base-400 mt-0.5">{{ feature.description | truncate: 65 }}</div>
        }
      </div>
      @if (feature.description && feature.description.length > 50) {
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
          class="w-3 h-3 mt-1 opacity-60 cursor-help hover:opacity-100 transition-opacity"
          [appTooltip]="feature.description"
          tooltipPosition="right"
          role="img" aria-label="Info">
          <path d="M4.545 4.5C4.66255 4.16583 4.89458 3.88405 5.19998 3.70457C5.50538 3.52508 5.86445 3.45947 6.21359 3.51936C6.56273 3.57924 6.87941 3.76076 7.10754 4.03176C7.33567 4.30277 7.46053 4.64576 7.46 5C7.46 6 5.96 6.5 5.96 6.5M6 8.5H6.005M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z" stroke="#5B6A8F" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      }
    </div>

    <!-- Plan Value Columns (with 2px left margin for gaps) -->
    @for (plan of plans; track plan.code; let idx = $index) {
      <div [class]="columnClass || 'px-4 py-3 flex items-center justify-center'" [style.margin-left]="idx > 0 ? '2px' : '0'">
        @let featureValue = getFeatureValue(feature, plan.code);
        @if (featureValue.enabled) {
          @if (shouldShowFeatureLabel(feature, plan.code)) {
            <div [appTooltip]="featureValue.hint || ''" class="flex flex-col items-center justify-center">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" role="img" aria-label="Included">
                <path d="M25.3207 25.3334H25.3334ZM25.3207 25.3334C24.4904 26.1567 22.9858 25.9516 21.9306 25.9516C20.6354 25.9516 20.0116 26.205 19.0872 27.1294C18.3002 27.9166 17.245 29.3334 16 29.3334C14.7551 29.3334 13.6999 27.9166 12.9128 27.1294C11.9884 26.205 11.3647 25.9516 10.0694 25.9516C9.01426 25.9516 7.50959 26.1567 6.67934 25.3334C5.84243 24.5035 6.04839 22.9926 6.04839 21.9306C6.04839 20.5886 5.7549 19.9715 4.79919 19.0158C3.37754 17.5942 2.66671 16.8832 2.66669 16C2.6667 15.1167 3.37751 14.4059 4.79915 12.9842C5.65229 12.1311 6.04839 11.2857 6.04839 10.0694C6.04839 9.01422 5.84334 7.50954 6.66669 6.67927C7.49659 5.84239 9.00749 6.04837 10.0695 6.04837C11.2857 6.04837 12.1311 5.65229 12.9842 4.79918C14.4059 3.37751 15.1167 2.66669 16 2.66669C16.8834 2.66669 17.5942 3.37751 19.0158 4.79918C19.8687 5.65211 20.714 6.04837 21.9306 6.04837C22.9858 6.04837 24.4906 5.84331 25.3208 6.66669C26.1576 7.49659 25.9516 9.00747 25.9516 10.0694C25.9516 11.4115 26.2452 12.0285 27.2008 12.9842C28.6226 14.4059 29.3334 15.1167 29.3334 16C29.3334 16.8832 28.6226 17.5942 27.2008 19.0158C26.2451 19.9715 25.9516 20.5886 25.9516 21.9306C25.9516 22.9926 26.1576 24.5035 25.3207 25.3334Z" [attr.fill]="plan.code === 'plan-enterprise' ? '#6866FF' : '#FFA059'"/>
                <path d="M12 17.1906L14.4 19.3334L20 12.6667" stroke="white" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              @if (featureValue.label) {
                <span class="text-xs text-center" [appTooltip]="featureValue.label.length > 25 ? featureValue.label : ''" tooltipPosition="bottom"
                  [ngClass]="plan.code === 'plan-enterprise' ? 'text-brand-purple-600' : 'text-brand-orange-600'">{{ featureValue.label | truncate: 25 }}</span>
              }
            </div>
          } @else {
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6" [appTooltip]="featureValue.hint || ''" role="img" aria-label="Included">
              <path d="M25.3207 25.3334H25.3334ZM25.3207 25.3334C24.4904 26.1567 22.9858 25.9516 21.9306 25.9516C20.6354 25.9516 20.0116 26.205 19.0872 27.1294C18.3002 27.9166 17.245 29.3334 16 29.3334C14.7551 29.3334 13.6999 27.9166 12.9128 27.1294C11.9884 26.205 11.3647 25.9516 10.0694 25.9516C9.01426 25.9516 7.50959 26.1567 6.67934 25.3334C5.84243 24.5035 6.04839 22.9926 6.04839 21.9306C6.04839 20.5886 5.7549 19.9715 4.79919 19.0158C3.37754 17.5942 2.66671 16.8832 2.66669 16C2.6667 15.1167 3.37751 14.4059 4.79915 12.9842C5.65229 12.1311 6.04839 11.2857 6.04839 10.0694C6.04839 9.01422 5.84334 7.50954 6.66669 6.67927C7.49659 5.84239 9.00749 6.04837 10.0695 6.04837C11.2857 6.04837 12.1311 5.65229 12.9842 4.79918C14.4059 3.37751 15.1167 2.66669 16 2.66669C16.8834 2.66669 17.5942 3.37751 19.0158 4.79918C19.8687 5.65211 20.714 6.04837 21.9306 6.04837C22.9858 6.04837 24.4906 5.84331 25.3208 6.66669C26.1576 7.49659 25.9516 9.00747 25.9516 10.0694C25.9516 11.4115 26.2452 12.0285 27.2008 12.9842C28.6226 14.4059 29.3334 15.1167 29.3334 16C29.3334 16.8832 28.6226 17.5942 27.2008 19.0158C26.2451 19.9715 25.9516 20.5886 25.9516 21.9306C25.9516 22.9926 26.1576 24.5035 25.3207 25.3334Z" [attr.fill]="plan.code === 'plan-enterprise' ? '#6866FF' : '#FFA059'"/>
              <path d="M12 17.1906L14.4 19.3334L20 12.6667" stroke="white" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
        } @else {
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" role="img" aria-label="Not included">
            <path d="M29.3334 16.0001C29.3334 8.63628 23.3638 2.66675 16 2.66675C8.63622 2.66675 2.66669 8.63628 2.66669 16.0001C2.66669 23.3638 8.63622 29.3334 16 29.3334C23.3638 29.3334 29.3334 23.3638 29.3334 16.0001Z" fill="#BEC8DA"/>
            <path d="M19.9992 20L12 12M12.0009 20L20 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        }
      </div>
    }
  </div>
</ng-template>

<!-- Reusable Feature Row Template - Mobile (per Figma 31-1718) -->
<ng-template #featureRowMobileTpl let-feature let-plans="plans">
  <div class="flex items-center h-16 odd:bg-gray-50 even:bg-white">
    <!-- Feature Name Column - 120px fixed -->
    <div class="w-[120px] flex-shrink-0 px-2 py-2">
      <div class="text-sm font-medium text-base-700 leading-tight" [appTooltip]="feature.name">{{ feature.name | truncate: 22 }}</div>
    </div>

    <!-- Plan Value Columns - flex remaining space -->
    <div class="flex-1 flex">
      @for (plan of plans; track plan.code) {
        <div class="flex-1 flex items-center justify-center py-2">
          @let featureValue = getFeatureValue(feature, plan.code);
          @if (featureValue.enabled) {
            @if (shouldShowFeatureLabel(feature, plan.code) && featureValue.label) {
              <span class="text-xs text-center" [appTooltip]="featureValue.label.length > 25 ? featureValue.label : ''" tooltipPosition="bottom"
                [ngClass]="plan.code === 'plan-enterprise' ? 'text-brand-purple-600' : 'text-brand-orange-600'">{{ featureValue.label | truncate: 25 }}</span>
            } @else {
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" role="img" aria-label="Included">
                <path d="M25.3207 25.3334H25.3334ZM25.3207 25.3334C24.4904 26.1567 22.9858 25.9516 21.9306 25.9516C20.6354 25.9516 20.0116 26.205 19.0872 27.1294C18.3002 27.9166 17.245 29.3334 16 29.3334C14.7551 29.3334 13.6999 27.9166 12.9128 27.1294C11.9884 26.205 11.3647 25.9516 10.0694 25.9516C9.01426 25.9516 7.50959 26.1567 6.67934 25.3334C5.84243 24.5035 6.04839 22.9926 6.04839 21.9306C6.04839 20.5886 5.7549 19.9715 4.79919 19.0158C3.37754 17.5942 2.66671 16.8832 2.66669 16C2.6667 15.1167 3.37751 14.4059 4.79915 12.9842C5.65229 12.1311 6.04839 11.2857 6.04839 10.0694C6.04839 9.01422 5.84334 7.50954 6.66669 6.67927C7.49659 5.84239 9.00749 6.04837 10.0695 6.04837C11.2857 6.04837 12.1311 5.65229 12.9842 4.79918C14.4059 3.37751 15.1167 2.66669 16 2.66669C16.8834 2.66669 17.5942 3.37751 19.0158 4.79918C19.8687 5.65211 20.714 6.04837 21.9306 6.04837C22.9858 6.04837 24.4906 5.84331 25.3208 6.66669C26.1576 7.49659 25.9516 9.00747 25.9516 10.0694C25.9516 11.4115 26.2452 12.0285 27.2008 12.9842C28.6226 14.4059 29.3334 15.1167 29.3334 16C29.3334 16.8832 28.6226 17.5942 27.2008 19.0158C26.2451 19.9715 25.9516 20.5886 25.9516 21.9306C25.9516 22.9926 26.1576 24.5035 25.3207 25.3334Z" [attr.fill]="plan.code === 'plan-enterprise' ? '#6866FF' : '#FFA059'"/>
                <path d="M12 17.1906L14.4 19.3334L20 12.6667" stroke="white" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            }
          } @else {
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" role="img" aria-label="Not included">
              <path d="M29.3334 16.0001C29.3334 8.63628 23.3638 2.66675 16 2.66675C8.63622 2.66675 2.66669 8.63628 2.66669 16.0001C2.66669 23.3638 8.63622 29.3334 16 29.3334C23.3638 29.3334 29.3334 23.3638 29.3334 16.0001Z" fill="#BEC8DA"/>
              <path d="M19.9992 20L12 12M12.0009 20L20 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
        </div>
      }
    </div>
  </div>
</ng-template>

<div class="space-y-0">
  <!-- Feature Groups (only in full mode) -->
  @if (showGroups()) {
    @for (group of filteredFeatureGroups(); track group.id) {
      <div class="feature-group-section">
        <!-- Group Header -->
        <div [class]="isMobile() ? 'px-2 py-3' : 'px-4 pt-10 pb-5'" [attr.data-section-name]="group.title">
          <h3 [class]="isMobile() ? 'text-base font-bold text-base-700' : 'text-xl font-bold text-base-700'">{{ group.title }}</h3>
        </div>

        <!-- Feature Rows -->
        <div class="bg-white overflow-hidden">
          @for (feature of group.features; track feature.code) {
            @if (isMobile()) {
              <ng-container *ngTemplateOutlet="featureRowMobileTpl; context: { 
                $implicit: feature, 
                plans: plans(),
              }"></ng-container>
            } @else {
              <ng-container *ngTemplateOutlet="featureRowTpl; context: { 
                $implicit: feature, 
                plans: plans(),
                columnClass: 'mx-4 pl-8 py-3 flex items-center justify-center feature-column'
              }"></ng-container>
            }
          }
        </div>
      </div>
    }
  }

  <!-- Ungrouped Features (both modes) -->
  @if (showUngrouped()) {
    @let ungroupedTitle = mode() === 'highlighted' ? 'Key Features' : 'Additional Features';
    <div class="feature-group-section">
      <!-- Group Header -->
      <div [class]="isMobile() ? 'px-2 py-3' : 'px-4 pt-10 pb-5'" [attr.data-section-name]="ungroupedTitle">
        <h3 [class]="isMobile() ? 'text-sm font-semibold text-base-700' : 'text-base font-semibold text-base-700'">{{ ungroupedTitle }}</h3>
      </div>

      <!-- Feature Rows -->
      <div class="overflow-hidden">
        @for (feature of filteredUngroupedFeatures(); track feature.code) {
          @if (isMobile()) {
            <ng-container *ngTemplateOutlet="featureRowMobileTpl; context: { 
              $implicit: feature, 
              plans: plans()
            }"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="featureRowTpl; context: { 
              $implicit: feature, 
              plans: plans(),
              columnClass: 'mx-4 pl-8 py-3 flex items-center justify-center feature-column'
            }"></ng-container>
          }
        }
      </div>
    </div>
  }

  <!-- Empty State -->
  @if (!hasFeatures()) {
    <div class="text-center py-16">
      <div class="text-6xl mb-4">📋</div>
      <h4 class="text-xl font-semibold text-gray-900 mb-2">No Features Available</h4>
      <p class="text-gray-600">Features will be displayed here when available.</p>
    </div>
  }
</div>
